"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRedux = require("react-redux");

var _react = _interopRequireWildcard(require("react"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _utils = require("../../../../configuration/utils");

var _constans = require("../../../../configuration/constans");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var LifeStyleImagesComponent = function LifeStyleImagesComponent() {
  var images = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.images;
  });
  var productName = (0, _reactRedux.useSelector)(function (state) {
    return state.selectedProduct.title;
  });
  var isMobile = (0, _reactRedux.useSelector)(function (state) {
    return state.isMobile;
  });
  var lifestyleImages = images.filter(function (img) {
    return (0, _utils.checkIfLifestyleImg)((img === null || img === void 0 ? void 0 : img.cdnUrl) || '');
  }) || null;
  var lifeStyleImageLimit = (lifestyleImages === null || lifestyleImages === void 0 ? void 0 : lifestyleImages.length) === 3 ? 2 : 5;
  var lifestyleImagesSection = document.getElementsByClassName("lifestyle-images-section");

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      sliderCenterMode = _useState2[0],
      setSliderCenterMode = _useState2[1];

  (0, _react.useEffect)(function () {
    var main = document.getElementsByClassName("main__image");
    var secondary = document.getElementsByClassName("secondary__images");
    var imageContainer = document.getElementsByClassName("image__container");

    _utils.importerExternalScripts.urls(["https://cdnjs.cloudflare.com/ajax/libs/color-thief/2.3.2/color-thief.min.js"]).then(function (r) {
      var _images$;

      var colorThief = new ColorThief();
      var img = new Image();
      var imageURL = images.length < 2 ? null : ((_images$ = images[1]) === null || _images$ === void 0 ? void 0 : _images$.cdnUrl) || '';
      var googleProxyURL = "https://images1-focus-opensocial.googleusercontent.com/gadgets/proxy?container=focus&refresh=2592000&url=";
      img.crossOrigin = "Anonymous"; // img.src = imageURL;

      img.src = googleProxyURL + encodeURIComponent(imageURL);

      img.onload = function () {
        var rgbArray = [];
        rgbArray.push(colorThief.getColor(img));
        lifestyleImagesSection[0].style.backgroundColor = "rgb(".concat(rgbArray[0][0], ",").concat(rgbArray[0][1], ",").concat(rgbArray[0][2], ")");
      };
    });

    var timer = setTimeout(function () {
      lifestyleImages.map(function (img, index) {
        lifestyleImagesSection[0].style.display = "flex";

        if (isMobile) {
          var slickSlide = document.querySelectorAll(".lifestyle-images-section .slider_wrapper .slick-slider .slick-list .slick-track .slick-slide");
          slickSlide.forEach(function (slide) {
            if (index > 0 && index < 2 || index === 3) {
              slide.classList.add("adjsutImg");
            } else {
              slide.classList.remove("adjsutImg");
              slide.style.marginBottom = "".concat(30, "px");
            }

            if (lifestyleImages.length === 1) {
              slide.style["float"] = 'none';
              slide.style.marginLeft = 'auto';
              slide.style.marginRight = 'auto';
            }
          });
        }
      });

      if (!isMobile) {
        var image2 = document.getElementsByClassName("image2");
        var image3 = document.getElementsByClassName("image3");
        var image4 = document.getElementsByClassName("image4");
        lifestyleImages.map(function (img, index) {
          if (!main[0].children[0]) {
            main[0].style.height = "".concat(400, "px");
            Array.from(secondary[0].children).forEach(function (child) {
              child.style.width = "".concat(100, "%");
              child.style.height = "".concat(100, "%");
              child.style.borderLeft = "".concat(0, "px");
            });

            if (secondary[0].children.length === 2) {
              imageContainer[0].style.transform = "translate(-100%, 0)";
              Array.from(secondary[0].children).forEach(function (child) {
                child.style.borderBottom = "".concat(0, "px");
              });
            } else {
              imageContainer[0].style.transform = "translate(-75%, 0)";
            }
          }

          if (index === 1 && secondary[0].children.length <= 1) {
            Array.from(secondary[0].children).forEach(function (child) {
              child.style.width = "".concat(100, "%");
              child.style.height = "".concat(100, "%");
              child.style.borderBottom = "none";
            });

            if (index === 1 && secondary[0].children.length === 0) {
              imageContainer[0].style.transform = "translate(-24%, 0)";
            } else {
              imageContainer[0].style.transform = "translate(-50%, 0)";
            }
          }

          if (image2[0] && image3[0]) {
            if (index > 1 && index < 6 || index > 1 && index < 5) {
              imageContainer[0].style.transform = "translate(-44%, 0)";
              secondary[0].style.flexDirection = "";
            } else if (index > 1 && index <= 3) {
              imageContainer[0].style.transform = "translate(-36%, 0)";
              secondary[0].style.flexDirection = "column";
            }
          }

          if (image3[0] && image4[0]) {
            if (index > 1 && index <= 3) {
              imageContainer[0].style.transform = "translate(-36%, 0)";
              secondary[0].style.flexDirection = "column";
            }
          }

          if (image2[0] && image4[0]) {
            if (index > 1 && index <= 3) {
              imageContainer[0].style.transform = "translate(-36%, 0)";
              secondary[0].style.flexDirection = "column";
            }
          }
        });
      }

      if (images.length < 2) {
        return lifestyleImagesSection[0].style.padding = 0;
      }
    }, 3000);
    return function () {
      return clearTimeout(timer);
    };
  });
  (0, _react.useEffect)(function () {
    isMobile && lifestyleImages.length === 1 ? setSliderCenterMode(false) : setSliderCenterMode(true);
  }, [isMobile]);
  var imagesTab = {
    dots: true,
    infinite: true,
    centerMode: sliderCenterMode,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    variableWidth: true,
    focusOnSelect: true,
    beforeChange: function beforeChange(current, next) {
      images.forEach(function (imgEl, index) {
        if (next === index - 1 && index > 0 && index < 6) {
          _utils.importerExternalScripts.urls(["https://cdnjs.cloudflare.com/ajax/libs/color-thief/2.3.2/color-thief.min.js"]).then(function (r) {
            var colorThief = new ColorThief();
            var imgSlider = new Image();
            var imageURL = (0, _utils.resolveImage)(imgEl, _constans.fastlyCompressionQuery.lifestyleSection);
            var googleProxyURL = "https://images1-focus-opensocial.googleusercontent.com/gadgets/proxy?container=focus&refresh=2592000&url=";
            imgSlider.crossOrigin = "Anonymous"; // imgSlider.src = imageURL;

            imgSlider.src = googleProxyURL + encodeURIComponent(imageURL);

            imgSlider.onload = function () {
              var rgbArray = [];
              rgbArray.push(colorThief.getColor(imgSlider));
              lifestyleImagesSection[0].style.backgroundColor = "rgb(".concat(rgbArray[0][0], ",").concat(rgbArray[0][1], ",").concat(rgbArray[0][2], ")");
              lifestyleImagesSection[0].style.transition = "background-color 1000ms ease";
            };
          });
        }
      });
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, images.length < 2 ? "" : !isMobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "image__container ".concat(images.length <= 3 ? "center" : "", " ").concat(lifestyleImages.length === 1 ? "one-product" : "")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "main__image"
  }, lifestyleImages && lifestyleImages[0] && /*#__PURE__*/_react["default"].createElement("img", {
    src: (0, _utils.resolveImage)(lifestyleImages[0], _constans.fastlyCompressionQuery.lifestyleSection),
    alt: productName,
    height: "450",
    width: "650"
  })), lifestyleImages && lifestyleImages[0] && lifestyleImages.length > 1 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "secondary__images"
  }, lifestyleImages.slice(0, lifeStyleImageLimit).map(function (img, index) {
    var _lifestyleImages$;

    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, (img === null || img === void 0 ? void 0 : img.cdnUrl) !== ((_lifestyleImages$ = lifestyleImages[0]) === null || _lifestyleImages$ === void 0 ? void 0 : _lifestyleImages$.cdnUrl) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "images image".concat(index),
      style: {
        backgroundImage: "url(".concat((0, _utils.resolveImage)(img, _constans.fastlyCompressionQuery.lifestyleSection), ")")
      }
    }));
  })) : "")), isMobile && /*#__PURE__*/_react["default"].createElement("div", {
    className: "slider_wrapper ".concat(lifestyleImages.length === 1 ? "one-slide" : "")
  }, /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], imagesTab, lifestyleImages.map(function (img, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement("img", {
      style: {
        backgroundImage: "url(".concat((0, _utils.resolveImage)(img, _constans.fastlyCompressionQuery.lifestyleSection), ")")
      },
      height: "315",
      width: "315"
    }));
  }))));
};

var _default = LifeStyleImagesComponent;
exports["default"] = _default;